import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBriefcase, FiPlus, FiSettings, FiArrowRight, FiAlertCircle } from 'react-icons/fi';
import { PageComponent, Card, Button } from '../../components';
import Api from '../../Api';
import './style.css';

export default function CompanySelect() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem('authUser'));
      if (user && user.name) {
        setUserName(user.name.split(' ')[0]); // First name only
      }
    } catch (e) {
      // Ignore error
    }

    loadCompanies();
  }, []);

  async function loadCompanies() {
    try {
      // Don't set loading to true here to avoid flashing if it's a refresh
      // or handle it gracefully
      const data = await Api.getCompanies();
      if (Array.isArray(data)) {
        setCompanies(data);
      } else {
        setError('Não foi possível carregar as empresas.');
      }
    } catch (err) {
      setError('Erro ao carregar empresas. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  function handleSelectCompany(company) {
    localStorage.setItem('selectedCompany', JSON.stringify(company));
    navigate('/');
  }

  return (
    <>
      <div className="company-select-page">
        <div className="company-select-container">
          <div className="company-select-header">
            <h1 className="company-select-title">
              Olá, {userName || 'Bem-vindo'}! <span className="wave">👋</span>
            </h1>
            <p className="company-select-subtitle">
              Selecione a empresa que deseja acessar hoje.
            </p>
          </div>

          {loading && (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Carregando suas empresas...</p>
            </div>
          )}

          {error && (
            <div className="error-state">
              <FiAlertCircle size={48} />
              <p>{error}</p>
              <Button onClick={() => window.location.reload()}>Tentar Novamente</Button>
            </div>
          )}

          {!loading && !error && companies.length === 0 && (
            <div className="no-companies-state">
              <div className="no-companies-icon">
                <FiBriefcase size={64} />
              </div>
              <h2>Nenhuma empresa encontrada</h2>
              <p>Para começar, cadastre sua primeira empresa no sistema.</p>
              <Button onClick={() => navigate('/companies')} className="btn-start">
                <FiPlus size={20} /> Cadastrar Primeira Empresa
              </Button>
            </div>
          )}

          {!loading && !error && companies.length > 0 && (
            <>
              <div className="company-list">
                {companies.map(company => {
                  let logoUrl = null;

                  if (company.logo) {
                    if (company.logo.type === 'Buffer' && company.logo.data) {
                      const base64String = btoa(
                        new Uint8Array(company.logo.data).reduce(
                          (data, byte) => data + String.fromCharCode(byte),
                          ''
                        )
                      );
                      logoUrl = `data:image/png;base64,${base64String}`;
                    } else if (typeof company.logo === 'string') {
                      logoUrl = company.logo;
                    }
                  }

                  return (
                    <div
                      key={company.id}
                      className="company-list-item"
                      onClick={() => handleSelectCompany(company)}
                    >
                      <div className="company-list-avatar">
                        {logoUrl ? (
                          <img src={logoUrl} alt={company.corporate_name} />
                        ) : (
                          <div className="company-list-icon-fallback">
                            <FiBriefcase size={24} />
                          </div>
                        )}
                      </div>
                      <div className="company-list-info">
                        <div className="company-list-title">
                          {company.corporate_name}
                        </div>
                        <div className="company-list-subtitle">
                          {company.trade_name || 'Sem nome fantasia'}
                        </div>
                        {company.cnpj && (
                          <div className="company-list-meta">
                            CNPJ: {company.cnpj}
                          </div>
                        )}
                      </div>
                      <div className="company-list-arrow">
                        <FiArrowRight size={20} />
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="company-footer-actions">
                <button className="manage-link" onClick={() => navigate('/companies')}>
                  <FiSettings size={18} /> Gerenciar todas as empresas
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
